import { useEffect, useState } from 'react';

/** Bootstrap's `lg` breakpoint — the width at which the inspector splits in two. */
export const DESKTOP_QUERY = '(min-width: 992px)';

/**
 * Subscribe to a media query. Returns `false` when `matchMedia` is unavailable
 * (jsdom, older browsers) so callers degrade to the narrow layout instead of
 * throwing.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mql = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mql.matches);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}
